import { URL_REGEX_PATTERN, PHONE_REGEX_PATTERN, START_WITH_SPACE } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const PartnerCreateSchema = Yup.object().shape(
  {
    name: Yup.string()
      .trim()
      .max(255)
      .trim()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>)
      .matches(START_WITH_SPACE, {
        message: <Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>,
      }),

    email: Yup.string()
      .email(<Translation>{(t) => t('VALIDATE.VALID_EMAIL')}</Translation>)
      .max(255)
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_EMAIL')}</Translation>),

    phone: Yup.string()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PHONE')}</Translation>)
      .matches(PHONE_REGEX_PATTERN, {
        message: <Translation>{(t) => t('VALIDATE.VALID_PHONE')}</Translation>,
      }),

    address: Yup.string()
      .max(255)
      .trim()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_ADDRESS')}</Translation>)
      .matches(START_WITH_SPACE, {
        message: <Translation>{(t) => t('VALIDATE.START_WITH_SPACE')}</Translation>,
      }),

    loyalty_unit: Yup.string()
      .trim()
      .max(10, <Translation>{(t) => t('VALIDATE.VALID_LOYALTY_UNIT', { number: '10' })}</Translation>)
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_LOYALTY_UNIT')}</Translation>)
      .matches(START_WITH_SPACE, {
        message: <Translation>{(t) => t('VALIDATE.REQUIRED_LOYALTY_UNIT')}</Translation>,
      }),

    logo: Yup.array()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_FILE')}</Translation>)
      .min(1, <Translation>{(t) => t('VALIDATE.MIN_FILE', { number: '1' })}</Translation>)
      .max(1, <Translation>{(t) => t('VALIDATE.MAX_FILE', { number: '1' })}</Translation>),

    favicon: Yup.array()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_FILE')}</Translation>)
      .min(1, <Translation>{(t) => t('VALIDATE.MIN_FILE', { number: '1' })}</Translation>)
      .max(1, <Translation>{(t) => t('VALIDATE.MAX_FILE', { number: '1' })}</Translation>),

    slider: Yup.array()
      .min(1, <Translation>{(t) => t('VALIDATE.MIN_FILE', { number: '1' })}</Translation>)
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_FILE')}</Translation>),

    home_page_link: Yup.string()
      .nullable()
      .notRequired()
      .when('home_page_link', {
        is: (value) => value?.length,
        then: (rule) =>
          rule.matches(URL_REGEX_PATTERN, {
            message: <Translation>{(t) => t('VALIDATE.HOME_PAGE_LINK')}</Translation>,
          }),
      }),
  },
  [['home_page_link', 'home_page_link']]
)

export default PartnerCreateSchema
